import { createStyles, makeStyles } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';
const {
  DARK_HEADER_LINE,
  DARK_CONTAINER_FIELDS_ON_CARD,
  DARK_ICON,
  LIGHT_HEADER_LINE,
  LIGHT_CONTAINER_FIELDS_ON_CARD,
  PLAIN_ICON,
  PLAIN_TEXT,
} = COLORS;

export const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      gap: 20,
      marginBottom: 10,
      [theme.breakpoints.down(900)]: {
        gridTemplateColumns: 'unset',
        // width: 'calc(100% - 75px)',
      },
    },
    contentMain: {
      background: theme.palette.type === 'dark' ? DARK_CONTAINER_FIELDS_ON_CARD : LIGHT_CONTAINER_FIELDS_ON_CARD,

      border: 'none',
      borderRadius: 5,
      padding: '15px 20px',

      '& .MuiAccordionSummary-root.Mui-expanded': {
        marginBottom: 15,
      },

      '& .MuiAccordionSummary-content': {
        padding: '5px 0',

        '&.Mui-expanded': {
          paddingBottom: 10,
        },
      },

      '& .MuiAccordion-root': {
        background: 'transparent',
        boxShadow: 'none',

        '& .MuiAccordionSummary-expandIcon': {
          color: PLAIN_TEXT,
        },
      },
    },
    content: {
      // TBD if needed background
      // background: theme.palette.type === 'dark' ? DARK_CONTAINER_FIELDS_FLOATING : LIGHT_CONTAINER_FIELDS_FLOATING,

      border: 'none',
      borderRadius: 5,
      padding: '15px 20px',
      width: '100%',

      '& .MuiAccordionSummary-root.Mui-expanded': {
        marginBottom: 15,
      },

      '& .MuiAccordionSummary-content': {
        padding: '5px 0',

        '&.Mui-expanded': {
          paddingBottom: 10,
        },
      },

      '& .MuiAccordion-root': {
        background: 'transparent',
        boxShadow: 'none',

        '& .MuiAccordionSummary-expandIcon': {
          color: DARK_ICON,
        },
      },
    },
    accordionSummary: {
      borderBottom: theme.palette.type === 'dark' ? `1px solid ${DARK_HEADER_LINE}` : `1px solid ${LIGHT_HEADER_LINE}`,
      '& .MuiAccordionSummary-expandIcon': {
        color: (theme.palette.type === 'dark' ? PLAIN_ICON : DARK_ICON) + ' !important',
      },
    },
  }),
);
